import { Controller } from "@hotwired/stimulus"
import { sendFailureNotification } from "shared/toast_notifications"
import { getOrganizations } from "shared/organization/list"
import { getCsrfToken } from "shared/form_helpers"

// Connects to data-controller="organizations"
export default class extends Controller {

    static targets = ["table"]

    connect() {
        this.fetchOrganizations()
    }

    async fetchOrganizations() {
        const argusTable = this._getArgusTable()
        if (argusTable) {
            argusTable.showLoading()
        }

        try {
            const organizations = await getOrganizations()
            this.renderTable(organizations)
        } catch (error) {
            console.error("Error fetching organizations:", error)
            sendFailureNotification(error.message)
        } finally {
            if (argusTable) {
                argusTable.hideLoading()
            }
        }
    }

    renderTable(organizations) {
        const argusTable = this._getArgusTable()
        if (!argusTable) {
            return
        }

        argusTable.loadData(organizations || [])
    }

    async federate(event) {
        const orgId = event.currentTarget.dataset.orgId
        try {
            const response = await fetch('/api/organization/federate', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': getCsrfToken(),
                },
                body: JSON.stringify({ organization_id: orgId }),
            })

            if (!response.ok) {
                const data = await response.json()
                sendFailureNotification(data.message || 'Federation failed')
                return
            }

            // The previous organization's active project is cleared server-side, so send
            // the operator to project selection for the new organization.
            window.location.href = '/projects/select'
        } catch (error) {
            console.error('Federation error:', error)
            sendFailureNotification('An unexpected error occurred')
        }
    }

    // Resolve the sibling argus--table controller that owns the shared
    // loading overlay and renders the organizations rows.
    _getArgusTable() {
        if (!this.hasTableTarget) {
            return null
        }
        return this.application.getControllerForElementAndIdentifier(
            this.tableTarget, 'argus--table'
        )
    }
}
